/*
  Koeln checkout redirect.
  Decides via SKU-prefix whether the cart should check out on dus.colognewatch.de.

  SKU convention (Cologne Watch):
    - AD*, KD*  -> Duesseldorf (Ankauf/Kommission DUS)
    - AK*, KK*  -> Koeln (Ankauf/Kommission Koeln)

  Cart policy: each cart contains exactly one product (enforced upstream).
  No Cloudways backend call; variant-id mapping happens on the DUS loading page
  via /products/<handle>.js using the SKU we pass through.
*/
$(document).ready(function () {
  var DUS_CHECKOUT_URL = "https://dus.colognewatch.de/pages/loading-page";
  var CHECKOUT_SELECTOR = ".cart__checkout-button, button[form='mini-cart-form']";
  var DUS_SKU_PREFIXES = ["AD", "KD"];

  var DECISION_LOADING = "loading";
  var DECISION_REDIRECT = "redirect";
  var DECISION_NORMAL = "normal";
  var DECISION_BLOCKED = "blocked";

  var decisionState = DECISION_LOADING;
  var redirectUrl = null;
  var blockMessage = null;
  var redirectInProgress = false;
  var pendingButton = null;
  var nativeCheckoutInProgress = false;

  function isEnglishLocale() {
    return !!(
      window.Shopify &&
      Shopify.locale &&
      String(Shopify.locale).toLowerCase().indexOf("en") === 0
    );
  }

  function getBlockedMessage(reason) {
    if (reason === "mixed") {
      return isEnglishLocale()
        ? "This cart contains a Duesseldorf watch together with another item. Please check out this watch separately."
        : "Dieser Warenkorb enthält eine Düsseldorf-Uhr zusammen mit einem weiteren Artikel. Bitte lege diese Uhr einzeln in den Warenkorb.";
    }

    return isEnglishLocale()
      ? "We could not safely verify the correct checkout location. Please reload the cart and try again."
      : "Der richtige Checkout-Standort konnte nicht sicher geprüft werden. Bitte lade den Warenkorb neu und versuche es erneut.";
  }

  function getCookieValue(cookieName) {
    var prefix = cookieName + "=";
    var parts = document.cookie ? document.cookie.split("; ") : [];

    for (var i = 0; i < parts.length; i += 1) {
      if (parts[i].indexOf(prefix) === 0) {
        return parts[i].substring(prefix.length);
      }
    }

    return null;
  }

  function isDusSku(sku) {
    if (!sku) {
      return false;
    }

    var upper = String(sku).trim().toUpperCase();
    for (var i = 0; i < DUS_SKU_PREFIXES.length; i += 1) {
      if (upper.indexOf(DUS_SKU_PREFIXES[i]) === 0) {
        return true;
      }
    }

    return false;
  }

  function buildRedirectUrl(dusItems) {
    var checkoutUrl = new URL(DUS_CHECKOUT_URL);

    $.each(dusItems, function (index, item) {
      if (!item) {
        return;
      }

      checkoutUrl.searchParams.append("h", item.handle);
      checkoutUrl.searchParams.append("sku", item.sku);
      checkoutUrl.searchParams.append("q", item.quantity);
    });

    // ===== Tracking-Parameter für Cross-Domain Tracking =====
    var currentParams = new URLSearchParams(window.location.search);
    var trackingParams = [
      "fbclid",
      "gclid",
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_content",
      "utm_term",
      "_ga",
      "_gl",
    ];

    trackingParams.forEach(function (param) {
      var value = currentParams.get(param);
      if (value) {
        checkoutUrl.searchParams.append(param, value);
      }
    });

    // ===== Meta _fbc immer aus URL/Cookie weitergeben (Koeln -> DUS) =====
    var fbcFromUrl = currentParams.get("_fbc");
    var fbcValue = fbcFromUrl || getCookieValue("_fbc");
    if (fbcValue) {
      checkoutUrl.searchParams.append("_fbc", fbcValue);
    }

    // ===== Meta _fbp immer aus URL/Cookie weitergeben (Koeln -> DUS) =====
    var fbpFromUrl = currentParams.get("_fbp");
    var fbpValue = fbpFromUrl || getCookieValue("_fbp");
    if (fbpValue) {
      checkoutUrl.searchParams.append("_fbp", fbpValue);
    }
    // ===== Ende Tracking-Parameter =====

    return checkoutUrl.toString();
  }

  function setButtonsBusy(isBusy) {
    var $buttons = $(CHECKOUT_SELECTOR);

    $buttons.prop("disabled", !!isBusy).attr("aria-busy", !!isBusy ? "true" : "false");

    if (isBusy) {
      $buttons.attr("aria-disabled", "true");
    } else {
      $buttons.removeAttr("aria-disabled");
    }
  }

  function blockCheckout(message) {
    setButtonsBusy(false);
    redirectInProgress = false;

    if (message) {
      window.alert(message);
    }
  }

  function continueWithNativeCheckout(buttonElement) {
    var formElement = null;

    if (buttonElement && buttonElement.form) {
      formElement = buttonElement.form;
    } else if (buttonElement) {
      formElement = $(buttonElement).closest("form").get(0);
    }

    if (formElement) {
      nativeCheckoutInProgress = true;
      window.setTimeout(function () {
        nativeCheckoutInProgress = false;
      }, 1500);

      if (typeof formElement.requestSubmit === "function") {
        if (buttonElement && buttonElement.form === formElement) {
          formElement.requestSubmit(buttonElement);
        } else {
          formElement.requestSubmit();
        }
      } else {
        formElement.submit();
      }
      return;
    }

    var checkoutPath =
      window.Shopify && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root + "checkout"
        : "/checkout";

    window.location.href = checkoutPath;
  }

  function redirectToDusCheckout() {
    if (redirectInProgress) {
      return;
    }

    redirectInProgress = true;
    setButtonsBusy(true);

    if (!redirectUrl) {
      blockCheckout(getBlockedMessage("unverified"));
      return;
    }

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then(function () {
        window.location.href = redirectUrl;
      })
      .catch(function () {
        // Redirect trotzdem ausführen, damit der Checkout-Flow nicht hängen bleibt.
        window.location.href = redirectUrl;
      });
  }

  function loadDecision() {
    var deferred = $.Deferred();

    decisionState = DECISION_LOADING;
    redirectUrl = null;
    blockMessage = null;

    $.ajax({
      type: "GET",
      url: "/cart.json",
      cache: false,
      timeout: 8000,
    })
      .done(function (cartData) {
        var items = (cartData && cartData.items) ? cartData.items : [];
        var dusItems = [];
        var invalidDusItem = false;

        $.each(items, function (index, item) {
          if (!item || !isDusSku(item.sku)) {
            return;
          }

          if (!item.handle || !item.sku) {
            invalidDusItem = true;
            return false;
          }

          dusItems.push({
            handle: item.handle,
            sku: item.sku,
            quantity: item.quantity,
          });
        });

        if (invalidDusItem) {
          if (window.console && console.warn) {
            console.warn("localized-checkout: DUS cart item is missing handle or SKU; blocking checkout");
          }

          decisionState = DECISION_BLOCKED;
          blockMessage = getBlockedMessage("unverified");
          deferred.resolve();
          return;
        }

        // Defense: Cart-Policy sagt "immer genau 1 Artikel". Bei Policy-Verletzung (>1 Item)
        // mit DUS-Bezug blocken wir den Checkout, statt einen DUS-Artikel in Koeln durchzulassen
        // oder beim cart/clear.js andere Artikel zu verlieren.
        if (items.length > 1 && dusItems.length > 0) {
          if (window.console && console.warn) {
            console.warn("localized-checkout: cart has", items.length, "items including DUS item; blocking checkout");
          }

          decisionState = DECISION_BLOCKED;
          blockMessage = getBlockedMessage("mixed");
          deferred.resolve();
          return;
        }

        if (dusItems.length > 0) {
          try {
            decisionState = DECISION_REDIRECT;
            redirectUrl = buildRedirectUrl(dusItems);
          } catch (error) {
            if (window.console && console.warn) {
              console.warn("localized-checkout: failed to build DUS checkout URL; blocking checkout", error);
            }

            decisionState = DECISION_BLOCKED;
            blockMessage = getBlockedMessage("unverified");
          }
        } else {
          decisionState = DECISION_NORMAL;
        }

        deferred.resolve();
      })
      .fail(function () {
        // Ohne cart.json keine verlaessliche Standort-Entscheidung - deshalb fail-closed.
        if (window.console && console.warn) {
          console.warn("localized-checkout: failed to load /cart.json; blocking checkout");
        }

        decisionState = DECISION_BLOCKED;
        blockMessage = getBlockedMessage("unverified");
        deferred.resolve();
      });

    return deferred.promise();
  }

  function isCheckoutForm(formElement) {
    if (!formElement) {
      return false;
    }

    var action = formElement.getAttribute("action") || "";
    var hasCheckoutInput = $(formElement).find("[name='checkout']").length > 0;

    return hasCheckoutInput && action.indexOf("/cart") !== -1;
  }

  function handleCheckoutAttempt(event, buttonElement, formElement) {
    if (nativeCheckoutInProgress) {
      return;
    }

    if (redirectInProgress || pendingButton) {
      if (event) {
        event.preventDefault();
      }
      return;
    }

    if (event) {
      event.preventDefault();
    }

    pendingButton = buttonElement || (formElement ? $(formElement).find(CHECKOUT_SELECTOR).get(0) : null);
    setButtonsBusy(true);

    // Wichtig: Die Entscheidung wird absichtlich bei jedem Checkout-Versuch frisch geladen.
    // Ein Page-Load-Snapshot kann stale sein, wenn der Warenkorb danach per AJAX geaendert wurde.
    loadDecision().always(function () {
      var buttonToContinue = pendingButton;
      pendingButton = null;

      if (decisionState === DECISION_REDIRECT) {
        pendingButton = buttonToContinue;
        redirectToDusCheckout();
        return;
      }

      if (decisionState === DECISION_BLOCKED) {
        blockCheckout(blockMessage || getBlockedMessage("unverified"));
        return;
      }

      setButtonsBusy(false);
      continueWithNativeCheckout(buttonToContinue);
    });
  }

  // Event delegation verhindert Timing-Probleme und deckt dynamische DOM-Updates ab.
  $(document)
    .off("click.localizedCheckout", CHECKOUT_SELECTOR)
    .on("click.localizedCheckout", CHECKOUT_SELECTOR, function (event) {
      handleCheckoutAttempt(event, this, this.form || null);
    })
    .off("submit.localizedCheckout", "form")
    .on("submit.localizedCheckout", "form", function (event) {
      if (!isCheckoutForm(this)) {
        return;
      }

      handleCheckoutAttempt(event, event.originalEvent && event.originalEvent.submitter, this);
    });
});
